import * as angular from 'angular';
import 'angular-ui-router';
import permissions from 'application/detail/permissions.json';
import ChannelsView from './ChannelsView.html';
import { ChannelsController } from './ChannelsController';
import { InstagramController } from './instagram/InstagramController';
import InstagramContentView from './instagram/InstagramContentView.html';
import { InstagramService } from './instagram/InstagramService';
import FacebookLoginPopupService from '../../../facebook/FacebookLoginPopupService';
import MessengerContentViewDpr from './facebook/MessengerContentViewDpr.html';
import { MessengerControllerDpr } from './facebook/MessengerControllerDpr';
import { MessengerService } from './facebook/MessengerService';
import WorkplaceContentView from './workplace/WorkplaceContentView.html';
import { WorkplaceController } from './workplace/WorkplaceController';
import { WorkplaceSegmentService } from './workplace/WorkplaceSegmentService';
import { WorkplaceService } from './workplace/WorkplaceService';
import TelegramContentView from './telegram/TelegramContentView.html';
import { TelegramController } from './telegram/TelegramController';
import MailgunContentView from './mailgun/MailgunContentView.html';
import { MailgunController } from './mailgun/MailgunController';
import WhatsAppContentViewDpr from './whatsapp/WhatsAppContentViewDpr.html';
import { WhatsAppControllerDpr } from './whatsapp/WhatsAppControllerDpr';
import WhatsAppContentView from './whatsapp/WhatsAppContentView.html';
import { WhatsAppController } from './whatsapp/WhatsAppController';
import { WhatsAppServiceDpr } from './whatsapp/WhatsAppServiceDpr';
import { WhatsAppService } from './whatsapp/WhatsAppService';
import WhatsAppMfeView from './whatsapp/WhatsAppMfeView.html';
import { WhatsAppMfeController } from './whatsapp/WhatsAppMfeController';
import BlipChat2ContentView from './blipchat2/BlipChat2ContentView.html';
import { BlipChat2Controller } from './blipchat2/BlipChat2Controller';
import AppleBusinessChatContentView from './applebusinesschat/AppleBusinessChatContentView.html';
import { AppleBusinessChatController } from './applebusinesschat/AppleBusinessChatController';
import { AppleBusinessChatSegmentService } from './applebusinesschat/AppleBusinessChatSegmentService';
import MessengerContentView from './messenger/MessengerContentView.html';
import { MessengerController } from './messenger/MessengerController';
import { ChannelsSegmentService } from './ChannelsSegmentService';
import { ChannelsService } from './ChannelsService';
import { ChannelsFeatures } from './ChannelsFeatures';
import channels from './channels.json';
import facebook from 'modules/facebook';
import { FacebookService } from 'modules/facebook/FacebookService';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { channelsMessengerScriptSource, channelsWhatsAppScriptSource } from 'app.constants';
export const channelsStateName = 'auth.application.detail.channels';
export const appleBusinessChatStateName = `${channelsStateName}.businesschat`;
export const instagramStateName = `${channelsStateName}.instagram`;
export const messengerStateName = `${channelsStateName}.messenger`;
export const messengerStateNameDpr = `${channelsStateName}.messengerDpr`;
export const whatsAppStateName = `${channelsStateName}.whatsapp`;
export const whatsAppEmbeddedStateName = `${channelsStateName}.whatsapp-embedded`;
export const whatsAppMfeStateName = `${channelsStateName}.whatsapp-obo`;
const telegramStateName = 'auth.application.detail.channels.telegram';
const workplaceStateName = 'auth.application.detail.channels.workplace';
export default angular
    .module('channels', [
    'ui.router',
    'shared',
    'app.constants',
    facebook,
])
    .constant('Channels', channels)
    .service('WhatsAppServiceDpr', WhatsAppServiceDpr)
    .service('WhatsAppService', WhatsAppService)
    .service('MessengerService', MessengerService)
    .service('WorkplaceSegmentService', WorkplaceSegmentService)
    .service('WorkplaceService', WorkplaceService)
    .service('ChannelsService', ChannelsService)
    .service('ChannelsSegmentService', ChannelsSegmentService)
    .service('AppleBusinessChatSegmentService', AppleBusinessChatSegmentService)
    .service('InstagramService', InstagramService)
    .service('FacebookLoginPopupService', FacebookLoginPopupService)
    .service('FacebookService', FacebookService)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(channelsStateName, {
            url: '/channels',
            redirectTo: `${channelsStateName}.index`,
            data: {
                permissionClaim: permissions.channels.claim,
            },
            params: { area: 'channels' },
            onEnter: () => {
                return Promise.all([
                    MicroFrontendService.addSource(channelsMessengerScriptSource),
                    MicroFrontendService.addSource(channelsWhatsAppScriptSource),
                ]);
            },
        })
            .state(`${channelsStateName}.index`, {
            url: '/',
            data: {
                permissionClaim: permissions.channels.claim,
            },
            params: { area: 'channels' },
            views: {
                'content@auth.application.detail': {
                    template: ChannelsView,
                    controller: ChannelsController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state(whatsAppStateName, {
            url: '/whatsapp',
            views: {
                'content@auth.application.detail': {
                    template: WhatsAppContentViewDpr,
                    controller: WhatsAppControllerDpr,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: ['$state', async function ($state) {
                    const isWhatsAppEmbeddedSignupDisable = await ChannelsFeatures.isWhatsAppEmbedSignupDisable();
                    const isWhatsAppMfeEnabled = await ChannelsFeatures.isWhatsAppMfeEnabled();
                    if (isWhatsAppEmbeddedSignupDisable) {
                        if (isWhatsAppMfeEnabled) {
                            return $state.go(whatsAppMfeStateName);
                        }
                        return $state.go(whatsAppStateName);
                    }
                    else {
                        return $state.go(whatsAppEmbeddedStateName);
                    }
                }],
        })
            .state(whatsAppEmbeddedStateName, {
            url: '/whatsapp-embedded',
            views: {
                'content@auth.application.detail': {
                    template: WhatsAppContentView,
                    controller: WhatsAppController,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: ['$state', async function ($state) {
                    const isWhatsAppEmbeddedSignupDisable = await ChannelsFeatures.isWhatsAppEmbedSignupDisable();
                    const isWhatsAppMfeEnabled = await ChannelsFeatures.isWhatsAppMfeEnabled();
                    if (isWhatsAppEmbeddedSignupDisable) {
                        if (isWhatsAppMfeEnabled) {
                            return $state.go(whatsAppMfeStateName);
                        }
                        return $state.go(whatsAppStateName);
                    }
                    else {
                        return $state.go(whatsAppEmbeddedStateName);
                    }
                }],
        })
            .state(whatsAppMfeStateName, {
            url: '/whatsapp-obo',
            views: {
                'content@auth.application.detail': {
                    template: WhatsAppMfeView,
                    controller: WhatsAppMfeController,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: ['$state', async function ($state) {
                    const isWhatsAppEmbeddedSignupDisable = await ChannelsFeatures.isWhatsAppEmbedSignupDisable();
                    const isWhatsAppMfeEnabled = await ChannelsFeatures.isWhatsAppMfeEnabled();
                    if (isWhatsAppEmbeddedSignupDisable) {
                        if (isWhatsAppMfeEnabled) {
                            return $state.go(whatsAppMfeStateName);
                        }
                        return $state.go(whatsAppStateName);
                    }
                    else {
                        return $state.go(whatsAppEmbeddedStateName);
                    }
                }],
        })
            .state(messengerStateName, {
            url: '/messenger',
            views: {
                'content@auth.application.detail': {
                    template: MessengerContentView,
                    controller: MessengerController,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: ['$state', async function ($state) {
                    const isMessengerMfeEnabled = await ChannelsFeatures.isMessengerMfeEnabled();
                    if (isMessengerMfeEnabled) {
                        return $state.go(messengerStateName);
                    }
                    else {
                        return $state.go(messengerStateNameDpr);
                    }
                }],
        })
            .state(messengerStateNameDpr, {
            url: '/messengerDpr',
            views: {
                'content@auth.application.detail': {
                    template: MessengerContentViewDpr,
                    controller: MessengerControllerDpr,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: ['$state', async function ($state) {
                    const isMessengerMfeEnabled = await ChannelsFeatures.isMessengerMfeEnabled();
                    if (isMessengerMfeEnabled) {
                        return $state.go(messengerStateName);
                    }
                    else {
                        return $state.go(messengerStateNameDpr);
                    }
                }],
        })
            .state(workplaceStateName, {
            url: '/workplace',
            views: {
                'content@auth.application.detail': {
                    template: WorkplaceContentView,
                    controller: WorkplaceController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.channels.claim,
            },
            params: { area: 'channels' },
        })
            .state(`${channelsStateName}.blipchat2`, {
            url: '/blipchat2.0',
            views: {
                'content@auth.application.detail': {
                    template: BlipChat2ContentView,
                    controller: BlipChat2Controller,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.channels.claim,
            },
            params: { area: 'channels' },
        })
            .state(telegramStateName, {
            url: '/telegram',
            views: {
                'content@auth.application.detail': {
                    template: TelegramContentView,
                    controller: TelegramController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state(`${channelsStateName}.mailgun`, {
            url: '/mailgun',
            views: {
                'content@auth.application.detail': {
                    template: MailgunContentView,
                    controller: MailgunController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state(appleBusinessChatStateName, {
            url: '/applebusinesschat',
            views: {
                'content@auth.application.detail': {
                    template: AppleBusinessChatContentView,
                    controller: AppleBusinessChatController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state(instagramStateName, {
            url: '/instagram',
            views: {
                'content@auth.application.detail': {
                    template: InstagramContentView,
                    controller: InstagramController,
                    controllerAs: '$ctrl',
                },
            },
        });
    }])
    .run(['$rootScope', '$window', function ($rootScope, $window) {
    }]).name;
